import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getRequestsToApprove } from "../../actions/index";
import { isLoading } from "../../selectors";
import _ from "lodash";
import { NavLink } from "react-router-dom";

const RequestsHeaderButton = ({ requests, getRequestsToApprove }) => {
  useEffect(() => {
    getRequestsToApprove();
  }, [getRequestsToApprove]);

  return <NavLink to="/requests">({requests.length}) Requests</NavLink>;
};

RequestsHeaderButton.propTypes = {
  getRequestsToApprove: PropTypes.func,
  loading: PropTypes.bool,
  requests: PropTypes.array,
};

export default connect(
  (state) => ({
    loading: isLoading(state, "getRequestsToApprove"),
    requests: _.filter(
      state.applicationRequests.toApprove,
      (p) => p.status === "Pending",
    ),
  }),
  {
    getRequestsToApprove,
  },
)(RequestsHeaderButton);
